import { render, staticRenderFns } from "./face_asset_list.vue?vue&type=template&id=0f7b0a6a&lang=pug&"
import script from "./face_asset_list.vue?vue&type=script&lang=js&"
export * from "./face_asset_list.vue?vue&type=script&lang=js&"
import style0 from "./face_asset_list.vue?vue&type=style&index=0&id=0f7b0a6a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports